import { stringify } from 'qs';
function paramsSerializer(params) {
    return stringify(params, {
        filter: (prefix, value) => {
            if (Array.isArray(value)) {
                return JSON.stringify(value);
            }
            if (prefix === 'query') {
                return JSON.stringify(value);
            }
            return value;
        },
    });
}
export default paramsSerializer;
//# sourceMappingURL=paramSerializer.js.map